export const SubscriptionTypes = {
  GET_SUBSCRIPTION_HISTORY: 'GET_SUBSCRIPTION_HISTORY',
  CLEAR_SUBSCRIPTION_HISTORY: 'CLEAR_SUBSCRIPTION_HISTORY',
};
